import { render, staticRenderFns } from "./PublicProfileViewAs.vue?vue&type=template&id=322ab17a&scoped=true&"
import script from "./PublicProfileViewAs.vue?vue&type=script&lang=js&"
export * from "./PublicProfileViewAs.vue?vue&type=script&lang=js&"
import style0 from "./PublicProfileViewAs.vue?vue&type=style&index=0&id=322ab17a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322ab17a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VCol,VDialog,VIcon,VRow})
